var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68F276",
    d: "M8.25.574c-.606.113-1.318.357-2.412.732l-.573.196C2.258 2.53.755 3.045.378 3.583.008 4.11 0 5.651 0 8.71l8.25-2.75zM8.25 7.541 0 10.291v.201c0 5.638 4.239 8.374 6.899 9.536.51.223.84.367 1.351.433zM9.75 20.46V7.541l8.25 2.75v.201c0 5.638-4.239 8.374-6.899 9.536-.51.223-.84.367-1.351.433M9.75 5.96V.574c.606.113 1.318.357 2.412.732l.573.196c3.007 1.029 4.51 1.543 4.887 2.081.37.526.378 2.068.378 5.127z"
  })));
};
export default SvgShield;